import { render, staticRenderFns } from "./menuAddContent.vue?vue&type=template&id=69033ab0&lang=pug"
import script from "./menuAddContent.vue?vue&type=script&lang=js"
export * from "./menuAddContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports